import React from "react";
import { Segment, Header } from "semantic-ui-react";
import { Field } from "redux-form";

function AMPA({ precios, setDescuentoAmpa, setIncrementoAmpa }) {
  return (
    <Segment>
      <Header as="h5">Socio AMPA:</Header>
      <div>
        <label>
          <Field
            id="ampa"
            name="ampa"
            type="radio"
            value="ampaSi"
            component="input"
          />
          {" SI es socio de AMPA del centro que organiza la escuela."}
          {precios &&
            precios.descuentoAmpa > 0 &&
            ` (Descuento:${precios.descuentoAmpa} €)`}
        </label>
      </div>
      <div>
        <label>
          <Field
            id="ampa"
            name="ampa"
            type="radio"
            value="ampaNo"
            component="input"
          />
          {
            " NO es socio de AMPA del centro que organiza la escuela. Incremento de 5€ que se donarán al AMPA que organiza."
          }
          {precios &&
            precios.incrementoAmpa > 0 &&
            ` (Incremento: ${precios.incrementoAmpa} €)`}
        </label>
      </div>
    </Segment>
  );
}

export default AMPA;



// WEBPACK FOOTER //
// ./src/pages/inscripcionesConfirmadas/inscripcionConfirmada/formularioInscripcion/AMPA.jsx